import { render, staticRenderFns } from "./ModulesScreen.vue?vue&type=template&id=0e87306a&"
import script from "./ModulesScreen.vue?vue&type=script&lang=ts&"
export * from "./ModulesScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports